import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { BestToStartWIthGameCard } from './BestToStartWIthGameCard';

interface Props {
  handleClick: (e: any) => void;
}
export const BestToStartGameCards = ({ handleClick }: Props) => {
  const bestToStartWith = useSelector((state: RootState) => state.game.bestToStartWith);

  return (
    <>
      {bestToStartWith.map((x) => (
        <BestToStartWIthGameCard
          gameName={x.gameName}
          image={x.image}
          onClick={(e) => handleClick(e)}
          key={x.gameName + Math.random()}
          id={x.gameType}
        />
      ))}
    </>
  );
};
